export const LabelSupplierPage = () => {
    return <>LabelSupplierPage</>
}
